import * as actions from '../actionTypes';
import dateTimeHelpers from '../utils/dateTimeHelpers';

const initialState = {
  isLoading: true,
  selectedDay: dateTimeHelpers.today().date,
  restaurantSchedule: {},
};

const restaurantSchedule = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_RESTAURANT_MEAL_SCHEDULE:
      return { ...state, ...action.payload, isLoading: true };
    case actions.GET_RESTAURANT_MEAL_SCHEDULE_SUCCESS:
      return {
        ...state,
        restaurantSchedule: action.payload.data,
        isLoading: false,
      };
    case actions.GET_RESTAURANT_MEAL_SCHEDULE_FAILED:
      return { ...state, ...action.payload, isLoading: false };
    case actions.SET_SELECTED_DAY_FOR_MEAL_SCHEDULE:
      return { ...state, selectedDay: action.payload };
    case actions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};

export default restaurantSchedule;
